import styled, { css } from 'styled-components';

export const BannerPrincipal = styled.section`
  background: #e9ebed;
  h1 {
    margin-bottom: 16px;
    max-width: 574px;
  }
  p {
    max-width: 500px;
    strong {
      font-weight: normal;
      position: relative;
      z-index: 9;
      &:after {
        background: #364ef7;
        content: '';
        display: inline-block;
        height: 10px;
        left: 0;
        position: absolute;
        top: 60%;
        transition: 0.3s;
        width: 100%;
        z-index: -9;
      }
    }
  }
`;

export const Right = styled.div`
  width: 60%;
  img {
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
        }
      `
    );
  }}
`;

export const Left = styled.div`
  width: 40%;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
          padding-right: 0;
          margin-top: 0;
          margin-bottom: calc(30px / 2);
        }
      `
    );
  }}
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
